import { AxiosInstance } from 'axios';

export const addAcceptLanguageInterceptors = (axios: AxiosInstance, locale: string): (() => void) => {
    const acceptLanguageInterceptor = axios.interceptors.request.use((config) => {
        config.headers['Accept-Language'] = locale;

        return config;
    });

    return () => {
        axios.interceptors.request.eject(acceptLanguageInterceptor);
    };
};
